import { atom } from "recoil";

export const Rooms = atom({
  key: "Rooms", // unique ID (with respect to other atoms/selectors)
  default: [{ NbChamber: 1, NbAdult: 1, NbEnfant: 0, ChildAges: [] }],
});
